import {
  FormContainer,
  FormContainerItem,
  TextField,
  WarningBanner,
  WarningDialog,
} from "@graffer-inc/console-design-kit";
import { UserEntity } from "../../../../../application/domain/user/user-entity";
import React from "react";
import { ChangeAuthMethodService } from "../../../../../application/service/settings/users/change-auth-method-service";
import { toast } from "react-toastify";

type Props = {
  user: UserEntity;
  onCloseDialog: () => void;
};

export const ChangeAuthMethodToSAMLDialog: React.FC<Props> = ({
  user,
  onCloseDialog,
}) => {
  const [externalUserID, setExternalUserID] = React.useState<string>("");
  const [processErrorMessage, setProcessErrorMessage] = React.useState<
    string | null
  >(null);

  const onChangeExternalUserID = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setExternalUserID(event.target.value);
  };

  const onProcess = async () => {
    try {
      await ChangeAuthMethodService.ChangeAuthMethod(
        user,
        "saml",
        externalUserID,
      );

      toast.success("認証方式をSAML認証に変更しました");
      onCloseDialog();
    } catch (e) {
      setProcessErrorMessage(e.message);
    }
  };

  const onClose = () => {
    setProcessErrorMessage(null);
    onCloseDialog();
  };

  const dialogContent = () => {
    return (
      <section className="modal-card-body">
        {processErrorMessage && (
          <section style={{ marginBottom: "1.5rem" }}>
            <WarningBanner
              message="認証方式の変更に失敗しました"
              description={processErrorMessage}
            />
          </section>
        )}
        <p>以下のアカウントをSAML認証に切り替えます。</p>
        <section style={{ marginTop: "1.5rem" }}>
          <div className="field">
            <label className="label">ユーザーID</label>
            {user.id}
          </div>
          <div className="field">
            <label className="label">アカウント名</label>
            {user.accountName}
          </div>
          <div className="field">
            <label className="label">氏名</label>
            {user.name}
          </div>
          <div className="field">
            <label className="label">メールアドレス</label>
            {user.email || "未設定"}
          </div>
        </section>
        <section style={{ marginTop: "1.5rem" }}>
          <FormContainer>
            <FormContainerItem>
              <TextField
                description={
                  <>
                    SAML認証のIDプロバイダー側におけるユーザーIDを入力してください。
                  </>
                }
                label="外部ユーザーID"
                onChange={onChangeExternalUserID}
                placeholder="外部ユーザーID"
                required={true}
                value={externalUserID}
              />
            </FormContainerItem>
          </FormContainer>
          <div style={{ marginTop: "1.5rem" }}>
            <WarningBanner
              message="外部ユーザーIDが正しいかご確認ください"
              description="アカウントの紐づけに誤りがあると、別のユーザーがログインできる可能性があります。確認のうえ、変更してください。"
            />
          </div>
        </section>
      </section>
    );
  };

  return (
    <>
      <WarningDialog
        title={"SAML認証へ変更"}
        contents={dialogContent()}
        onCancel={onClose}
        cancelText="キャンセル"
        proceedText="変更する"
        onProceed={onProcess}
      />
    </>
  );
};
